// Shopify theme runtime bridge for LIFASE
window.LIFASE_Shopify = {
  async addToCart(variantId, quantity) {
    if (quantity === undefined) quantity = 1;
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      var data = await response.json();
      this.updateCartCount();
      return data;
    } catch (err) {
      console.error('Error adding to Shopify cart:', err);
    }
  },

  async buyNow(variantId, quantity) {
    if (quantity === undefined) quantity = 1;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      window.location.href = '/checkout';
    } catch (err) {
      window.location.href = '/checkout';
    }
  },

  async checkout() {
    window.location.href = '/checkout';
  },

  async getCart() {
    try {
      var res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      return null;
    }
  },

  async updateCartCount() {
    var cart = await this.getCart();
    if (cart) {
      document.querySelectorAll('#ShopifyCartCount').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }
  },

  async fetchAllProducts() {
    try {
      var res = await fetch('/products.json?limit=250');
      if (res.ok) {
        var data = await res.json();
        return data.products || [];
      }
    } catch (e) {
      console.warn('Could not fetch products via /products.json', e);
    }
    return [];
  }
};

// ---------------------------------------------------------------------
// LIFASE history bridge (unchanged - see earlier notes)
// ---------------------------------------------------------------------
(function () {
  function hashOf(url) {
    try {
      var a = document.createElement('a');
      a.href = url || window.location.href;
      return a.hash || '';
    } catch (e) {
      return window.location.hash || '';
    }
  }

  var lastHash = window.location.hash || '';
  var nativeReplaceState = window.history.replaceState.bind(window.history);

  window.history.replaceState = function (state, title, url) {
    var nextHash = hashOf(url);
    if (nextHash && nextHash !== lastHash) {
      lastHash = nextHash;
      return window.history.pushState(state, title, url);
    }
    return nativeReplaceState(state, title, url);
  };

  window.addEventListener('hashchange', function () {
    lastHash = window.location.hash || '';
  });
})();

// ---------------------------------------------------------------------
// LIFASE back button (unchanged - see earlier notes)
// ---------------------------------------------------------------------
(function () {
  var btn = null;

  function isHome() {
    var hash = (window.location.hash || '').replace(/^#\/?/, '');
    return hash === '';
  }

  function goBack() {
    if (window.history.length > 1) window.history.back();
    else window.location.hash = '';
  }

  function ensureButton() {
    if (isHome()) {
      if (btn) { btn.style.display = 'none'; }
      return;
    }
    if (!btn) {
      btn = document.createElement('button');
      btn.id = 'lifase-back-button';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Back');
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      btn.setAttribute('style', [
        'position:fixed',
        'top:calc(env(safe-area-inset-top, 0px) + 12px)',
        'left:12px',
        'z-index:2147483000',
        'width:40px',
        'height:40px',
        'border-radius:9999px',
        'border:none',
        'background:rgba(255,255,255,0.95)',
        'box-shadow:0 2px 10px rgba(15,23,42,0.18)',
        'display:flex',
        'align-items:center',
        'justify-content:center',
        'color:#0f172a',
        'cursor:pointer',
        'padding:0'
      ].join(';'));
      btn.addEventListener('click', goBack);
      document.body.appendChild(btn);
    }
    btn.style.display = 'flex';
  }

  window.addEventListener('hashchange', ensureButton);
  window.addEventListener('popstate', ensureButton);
  document.addEventListener('click', function () { window.setTimeout(ensureButton, 150); }, true);

  function start() { ensureButton(); }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

// Shared page-context helper: is the current view the cart, or a product?
function lifasePageContext() {
  var hash = (window.location.hash || '').toLowerCase();
  var path = (window.location.pathname || '').toLowerCase();
  var isCart = hash.indexOf('cart') !== -1 || path.indexOf('/cart') === 0;
  var products = (window.ShopifyTheme && window.ShopifyTheme.products) || [];
  var isProduct = false;
  for (var i = 0; i < products.length; i++) {
    var handle = (products[i].handle || products[i].slug || '').toLowerCase();
    if (handle && (hash.indexOf(handle) !== -1 || path.indexOf(handle) !== -1)) { isProduct = true; break; }
  }
  return { isCart: isCart, isProduct: isProduct };
}

// ---------------------------------------------------------------------
// LIFASE cart <-> screen sync (core)
//
// Root cause of the wrong checkout totals: the app keeps its own cart
// (what you see on the cart page) and never tells Shopify when you
// change it, so Shopify's real cart slowly fills with leftovers from
// earlier visits and tests. Checkout then shows Shopify's real, stale
// cart instead of what was on screen.
//
// Fix: at the moment you press checkout on the cart page, read exactly
// what the screen shows (product, variant, quantity), make Shopify's
// real cart match that exactly (replacing whatever was stale), and only
// then go to checkout. If the screen cannot be read with certainty, or
// the rebuild fails, nothing is changed (the previous real cart is
// restored) and checkout proceeds as before.
//
// Add ?lifase_debug=1 to the site address to see a small status box
// explaining what was read and what was done. Off by default.
// ---------------------------------------------------------------------
function lifaseDebugOn() {
  try {
    if (/[?&]lifase_debug=1/.test(window.location.search)) { window.localStorage.setItem('lifase_debug', '1'); return true; }
    if (/[?&]lifase_debug=0/.test(window.location.search)) { window.localStorage.removeItem('lifase_debug'); return false; }
    return window.localStorage.getItem('lifase_debug') === '1';
  } catch (e) { return false; }
}

var lifaseDbgLines = [];
function lifaseDbg(msg) {
  if (!lifaseDebugOn()) return;
  try {
    lifaseDbgLines.push(String(msg));
    if (lifaseDbgLines.length > 14) lifaseDbgLines.shift();
    var box = document.getElementById('lifase-debug-box');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'lifase-debug-box';
      box.setAttribute('style', 'position:fixed;left:0;right:0;top:0;z-index:2147483647;margin:0;padding:4px 6px;background:rgba(0,0,0,0.85);color:#7dffb2;font:9px/1.25 monospace;white-space:pre-wrap;max-height:45vh;overflow:auto;pointer-events:none;');
      (document.body || document.documentElement).appendChild(box);
    }
    box.textContent = lifaseDbgLines.join('\n');
  } catch (e) {}
}

function lifaseVisible(el) {
  if (!el) return false;
  try {
    if (typeof el.getClientRects === 'function') {
      var rects = el.getClientRects();
      if (rects && rects.length === 0) return false;
    }
  } catch (e) {}
  return true;
}

function lifaseLeafNumber(el) {
  if (!el) return null;
  var raw = '';
  if (el.tagName === 'INPUT') raw = el.value;
  else if (el.children && el.children.length === 0) raw = el.textContent;
  else return null;
  var t = (raw || '').trim();
  return /^\d{1,3}$/.test(t) ? parseInt(t, 10) : null;
}

// Quantity steppers look like: [button] number [button]
function lifaseFindSteppers() {
  var out = [];
  var cands = document.querySelectorAll('span, div, p, input');
  for (var i = 0; i < cands.length; i++) {
    var el = cands[i];
    var n = lifaseLeafNumber(el);
    if (n === null) continue;
    var prev = el.previousElementSibling;
    var next = el.nextElementSibling;
    if (prev && next && prev.tagName === 'BUTTON' && next.tagName === 'BUTTON' && lifaseVisible(next)) {
      out.push({ qty: n, anchor: next });
    }
  }
  if (out.length) return out;

  // Looser fallback: a visible "+" / "increase" button with a number beside it
  var btns = document.querySelectorAll('button');
  for (var j = 0; j < btns.length; j++) {
    var b = btns[j];
    var label = ((b.textContent || '') + ' ' + (b.getAttribute('aria-label') || '')).trim().toLowerCase();
    if (!(label === '+' || /\b(increase|plus)\b/.test(label))) continue;
    if (!lifaseVisible(b)) continue;
    var parent = b.parentElement;
    if (!parent) continue;
    var nodes = parent.querySelectorAll('span, div, p, input');
    for (var k = 0; k < nodes.length; k++) {
      var q = lifaseLeafNumber(nodes[k]);
      if (q !== null) { out.push({ qty: q, anchor: b }); break; }
    }
  }
  return out;
}

// Smallest ancestor of the stepper that contains exactly one product title.
function lifaseRowFor(startEl) {
  var products = (window.ShopifyTheme && window.ShopifyTheme.products) || [];
  var node = startEl;
  for (var depth = 0; depth < 10 && node && node !== document.body; depth++) {
    var text = node.textContent || '';
    var hits = [];
    for (var i = 0; i < products.length; i++) {
      var t = products[i].title;
      if (t && text.indexOf(t) !== -1) hits.push(products[i]);
    }
    if (hits.length === 1) return { product: hits[0], text: text };
    if (hits.length > 1) {
      hits.sort(function (a, b) { return b.title.length - a.title.length; });
      var longest = hits[0];
      var allInside = hits.every(function (h) { return longest.title.indexOf(h.title) !== -1; });
      return allInside ? { product: longest, text: text } : null;
    }
    node = node.parentElement;
  }
  return null;
}

function lifaseVariantForRow(product, text) {
  var vs = (product && product.variants) || [];
  if (!vs.length) return null;
  if (vs.length === 1) return vs[0];
  var lower = (text || '').toLowerCase();
  var best = null;
  for (var i = 0; i < vs.length; i++) {
    var vt = (vs[i].title || '').toLowerCase();
    if (!vt || vt === 'default title') continue;
    if (lower.indexOf(vt) !== -1 && (!best || vt.length > (best.title || '').length)) best = vs[i];
  }
  if (best) return best;
  for (var j = 0; j < vs.length; j++) {
    var parts = (vs[j].title || '').toLowerCase().split('/').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length > 1 && parts.every(function (p) { return lower.indexOf(p) !== -1; })) return vs[j];
  }
  return null;
}

// "Your Cart  [4 Items]" label, if present and unambiguous.
function lifaseCartCountLabel() {
  var found = null;
  var els = document.querySelectorAll('span, div, p');
  for (var i = 0; i < els.length; i++) {
    var el = els[i];
    if (el.children.length) continue;
    var m = (el.textContent || '').trim().match(/^(\d{1,3})\s+items?$/i);
    if (m) {
      var n = parseInt(m[1], 10);
      if (found !== null && found !== n) return null;
      found = n;
    }
  }
  return found;
}

function lifaseRowsFromDom() {
  var steppers = lifaseFindSteppers();
  if (!steppers.length) return { rows: null, reason: 'no quantity steppers found' };
  var seen = {};
  var rows = [];
  var total = 0;
  for (var i = 0; i < steppers.length; i++) {
    var s = steppers[i];
    var hit = lifaseRowFor(s.anchor);
    if (!hit) return { rows: null, reason: 'could not match stepper ' + i + ' to one product' };
    var variant = lifaseVariantForRow(hit.product, hit.text);
    if (!variant || !variant.id) return { rows: null, reason: 'variant unclear for ' + hit.product.title };
    if (!(s.qty >= 1)) return { rows: null, reason: 'quantity unreadable' };
    var key = String(variant.id);
    if (seen[key]) return { rows: null, reason: 'same item shown twice on screen' };
    seen[key] = true;
    rows.push({ id: variant.id, quantity: s.qty, title: hit.product.title });
    total += s.qty;
  }
  var label = lifaseCartCountLabel();
  if (label !== null && label !== total && label !== rows.length) {
    return { rows: null, reason: 'count label ' + label + ' does not match parsed ' + total };
  }
  return { rows: rows, reason: 'ok', total: total };
}

// ---- Backup reader: the app's own saved cart (browser storage) ----
function lifaseCollectArrays(data, depth, out) {
  if (depth > 3 || !data) return;
  if (Array.isArray(data)) { out.push(data); return; }
  if (typeof data === 'object') {
    Object.keys(data).forEach(function (k) { lifaseCollectArrays(data[k], depth + 1, out); });
  }
}

function lifaseMatchProduct(e, products) {
  var layers = [e, e.product, e.item, e.productData].filter(function (x) { return x && typeof x === 'object'; });
  for (var i = 0; i < layers.length; i++) {
    var c = layers[i];
    var keys = [c.id, c.productId, c.product_id, c.handle, c.slug, c.title, c.name];
    for (var j = 0; j < products.length; j++) {
      var p = products[j];
      for (var k = 0; k < keys.length; k++) {
        var v = keys[k];
        if (v === undefined || v === null || v === '') continue;
        var sv = String(v);
        if (sv === String(p.id) || sv === String(p.handle) || sv === String(p.slug) || sv === String(p.title)) return p;
      }
    }
  }
  return null;
}

function lifaseMatchStoredVariant(e, product) {
  var vs = product.variants || [];
  if (!vs.length) return null;
  if (vs.length === 1) return vs[0];
  var idKeys = [e.variantId, e.shopifyVariantId, e.variant_id, e.selectedVariantId, e.variant && e.variant.id];
  for (var i = 0; i < idKeys.length; i++) {
    if (idKeys[i] === undefined || idKeys[i] === null) continue;
    for (var j = 0; j < vs.length; j++) { if (String(vs[j].id) === String(idKeys[i])) return vs[j]; }
  }
  var texts = [e.selectedColor, e.color, e.variant, e.variantTitle, e.option, e.selectedOption, e.size, e.selectedSize, e.selectedVariant];
  var joined = texts.filter(function (t) { return typeof t === 'string'; }).join(' ');
  return lifaseVariantForRow(product, joined);
}

function lifaseParseCartArray(arr, products) {
  if (!arr.length || arr.length > 40) return null;
  var seen = {};
  var rows = [];
  for (var i = 0; i < arr.length; i++) {
    var e = arr[i];
    if (!e || typeof e !== 'object') return null;
    var q = e.quantity !== undefined ? e.quantity : (e.qty !== undefined ? e.qty : e.count);
    q = typeof q === 'string' ? parseInt(q, 10) : q;
    if (typeof q !== 'number' || !(q >= 1) || q > 99) return null;
    var p = lifaseMatchProduct(e, products);
    if (!p) return null;
    var v = lifaseMatchStoredVariant(e, p);
    if (!v || !v.id) return null;
    var key = String(v.id);
    if (seen[key]) return null;
    seen[key] = true;
    rows.push({ id: v.id, quantity: q, title: p.title });
  }
  return rows;
}

function lifaseRowsFromStorage(label) {
  if (label === null) return { rows: null, reason: 'storage reader needs the on-screen item count' };
  var products = (window.ShopifyTheme && window.ShopifyTheme.products) || [];
  if (!products.length) return { rows: null, reason: 'no product data' };
  var matches = [];
  var stores = [];
  try { stores.push(window.localStorage); } catch (e) {}
  try { stores.push(window.sessionStorage); } catch (e) {}
  stores.forEach(function (st) {
    try {
      for (var k = 0; k < st.length; k++) {
        var raw = st.getItem(st.key(k));
        if (!raw || raw.length > 300000) continue;
        var c = raw.charAt(0);
        if (c !== '[' && c !== '{') continue;
        var data;
        try { data = JSON.parse(raw); } catch (e) { continue; }
        var arrays = [];
        lifaseCollectArrays(data, 0, arrays);
        arrays.forEach(function (arr) {
          var rows = lifaseParseCartArray(arr, products);
          if (!rows) return;
          var total = rows.reduce(function (s, r) { return s + r.quantity; }, 0);
          if (total === label || rows.length === label) matches.push(rows);
        });
      }
    } catch (e) {}
  });
  if (!matches.length) return { rows: null, reason: 'no saved cart matched the on-screen count' };
  var sig = JSON.stringify(matches[0].map(function (r) { return r.id + ':' + r.quantity; }).sort());
  for (var m = 1; m < matches.length; m++) {
    if (JSON.stringify(matches[m].map(function (r) { return r.id + ':' + r.quantity; }).sort()) !== sig) {
      return { rows: null, reason: 'more than one different saved cart matched' };
    }
  }
  return { rows: matches[0], reason: 'ok' };
}

function lifaseReadCartRows() {
  var dom = lifaseRowsFromDom();
  if (dom.rows) return { rows: dom.rows, method: 'screen', reason: dom.reason };
  var store = lifaseRowsFromStorage(lifaseCartCountLabel());
  if (store.rows) return { rows: store.rows, method: 'storage', reason: store.reason };
  return { rows: null, method: 'none', reason: 'screen: ' + dom.reason + ' | storage: ' + store.reason };
}

function lifaseJsonHeaders() {
  return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
}

// Make Shopify's real cart exactly equal to `rows`; restore the old cart on any failure.
function lifaseSyncRealCart(rows) {
  var wanted = {};
  var expected = 0;
  rows.forEach(function (r) { wanted[String(r.id)] = r.quantity; expected += r.quantity; });
  var snapshot = [];
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (before) {
      var items = (before && before.items) || [];
      snapshot = items.map(function (it) { return { id: it.variant_id || it.id, quantity: it.quantity }; });
      var have = {};
      snapshot.forEach(function (s) { have[String(s.id)] = (have[String(s.id)] || 0) + s.quantity; });
      var wk = Object.keys(wanted);
      var hk = Object.keys(have);
      var same = wk.length === hk.length && wk.every(function (k) { return have[k] === wanted[k]; });
      if (same) { lifaseDbg('real cart already matches the screen'); return; }
      lifaseDbg('real cart differs from screen, rebuilding. had: ' + JSON.stringify(have));
      return fetch('/cart/clear.js', { method: 'POST', headers: lifaseJsonHeaders() })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: lifaseJsonHeaders(),
            body: JSON.stringify({ items: rows.map(function (r) { return { id: r.id, quantity: r.quantity }; }) })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add.js status ' + res.status);
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r2) { return r2.json(); });
        })
        .then(function (after) {
          if (!after || after.item_count !== expected) throw new Error('count ' + (after && after.item_count) + ' expected ' + expected);
          lifaseDbg('real cart rebuilt OK (' + expected + ' items)');
        })
        .catch(function (err) {
          lifaseDbg('rebuild failed: ' + err.message + ' - restoring previous cart');
          return fetch('/cart/clear.js', { method: 'POST', headers: lifaseJsonHeaders() })
            .then(function () {
              if (!snapshot.length) return;
              return fetch('/cart/add.js', { method: 'POST', headers: lifaseJsonHeaders(), body: JSON.stringify({ items: snapshot }) });
            })
            .then(function () { throw err; });
        });
    });
}

// ---------------------------------------------------------------------
// LIFASE real-cart bridge: Add to Cart / Buy Now / Clear Cart
// ---------------------------------------------------------------------
(function () {
  var ADD_INTENT = /add to (cart|bag)|add more|buy now/i;
  var CLEAR_INTENT = /clear cart/i;
  var lastAddedKey = '';

  function currentProduct() {
    var products = (window.ShopifyTheme && window.ShopifyTheme.products) || [];
    var loc = ((window.location.hash || '') + ' ' + (window.location.pathname || '')).toLowerCase();
    for (var i = 0; i < products.length; i++) {
      var handle = (products[i].handle || products[i].slug || '').toLowerCase();
      if (handle && loc.indexOf(handle) !== -1) return products[i];
    }
    return null;
  }

  function selectedVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (product.variants.length === 1) return product.variants[0];
    var bodyText = document.body ? document.body.innerText : '';
    var m = bodyText.match(/select[^:\n]*:\s*([a-z0-9 \-\/]{2,40})/i);
    if (m) {
      var v = lifaseVariantForRow(product, m[1]);
      if (v) return v;
    }
    var selectedEl = document.querySelector('[aria-selected="true"],[aria-checked="true"],input:checked');
    if (selectedEl) {
      var v2 = lifaseVariantForRow(product, (selectedEl.value || selectedEl.textContent || ''));
      if (v2) return v2;
    }
    return product.variants[0];
  }

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!el) return;
    var text = (el.textContent || '').trim();
    if (!ADD_INTENT.test(text)) return;

    var product = currentProduct();
    if (!product) return;
    var variant = selectedVariant(product);
    if (!variant || !variant.id) return;

    var key = variant.id + ':' + Math.floor(Date.now() / 1200);
    if (key === lastAddedKey) return;
    lastAddedKey = key;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    }).catch(function () {});
  }, true);

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!el) return;
    var text = (el.textContent || '').trim();
    if (!CLEAR_INTENT.test(text)) return;
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).catch(function () {});
  }, true);
})();

// ---------------------------------------------------------------------
// LIFASE checkout bridge
// ---------------------------------------------------------------------
var lifaseCheckoutBusy = false;
var LIFASE_CHECKOUT_INTENT = /checkout|payment|\bpay\b|place[-_ ]?order/i;
var LIFASE_HIJACK_RE = /(proceed|redirecting)[\s\S]*checkout|secure checkout/i;
var LIFASE_EXPRESS_RE = /buy now|express/i;
var LIFASE_COUPON_HINT = /promo|coupon|discount|lifase10|enter your code/i;

function lifaseOnCheckoutPage() {
  return window.location.pathname.indexOf('/checkout') === 0;
}

function lifaseFindCouponInput() {
  // Remember the box once found: its placeholder is changed below, so the
  // placeholder alone can no longer be used to find it afterwards.
  var marked = document.querySelector('input[data-lifase-coupon="1"]');
  if (marked) return marked;
  var inputs = document.querySelectorAll('input[type="text"], input:not([type])');
  for (var i = 0; i < inputs.length; i++) {
    var ph = (inputs[i].getAttribute('placeholder') || '');
    if (LIFASE_COUPON_HINT.test(ph)) {
      inputs[i].setAttribute('data-lifase-coupon', '1');
      return inputs[i];
    }
  }
  return null;
}

function lifaseFixCouponPlaceholder() {
  var input = lifaseFindCouponInput();
  if (input && input.getAttribute('placeholder') !== 'Enter your code') {
    input.setAttribute('placeholder', 'Enter your code');
  }
}

function lifaseSetBusy(btn, busy) {
  if (!btn) return;
  try {
    btn.disabled = !!busy;
    btn.textContent = busy ? 'Preparing secure checkout...' : 'Proceed to Secure Checkout';
    btn.style.opacity = busy ? '0.85' : '';
  } catch (e) {}
}

function lifaseGoCheckout() {
  var url = '/checkout';
  var couponInput = lifaseFindCouponInput();
  var code = couponInput && couponInput.value ? couponInput.value.trim() : '';
  if (code) url += '?discount=' + encodeURIComponent(code);
  window.location.href = url;
}

function lifaseStartCheckout(btn) {
  if (lifaseCheckoutBusy || lifaseOnCheckoutPage()) return;
  lifaseCheckoutBusy = true;
  lifaseSetBusy(btn, true);
  var safety = window.setTimeout(function () { lifaseCheckoutBusy = false; lifaseSetBusy(btn, false); }, 15000);
  var release = function () { window.clearTimeout(safety); lifaseCheckoutBusy = false; lifaseSetBusy(btn, false); };

  var plan = null;
  try { plan = lifasePageContext().isCart ? lifaseReadCartRows() : null; } catch (e) { lifaseDbg('screen read error: ' + e.message); }

  var sync = Promise.resolve();
  if (plan && plan.rows && plan.rows.length) {
    lifaseDbg('screen cart (' + plan.method + '): ' + plan.rows.map(function (r) { return r.quantity + 'x ' + r.id; }).join(', '));
    sync = lifaseSyncRealCart(plan.rows).catch(function (err) { lifaseDbg('sync error: ' + err.message); });
  } else {
    lifaseDbg('using real cart as-is. ' + (plan ? plan.reason : 'not on cart page'));
  }

  sync
    .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (cart && cart.item_count > 0) lifaseGoCheckout();
      else release();
    })
    .catch(function () { lifaseGoCheckout(); });
}

function lifaseHijackCheckoutButtons() {
  if (lifaseOnCheckoutPage()) return;
  var ctx = lifasePageContext();
  if (!ctx.isCart && !ctx.isProduct) return;

  // remove orphaned replacement buttons whose original is gone
  var mine = document.querySelectorAll('[data-lifase-checkout="mine"]');
  for (var m = 0; m < mine.length; m++) {
    var prev = mine[m].previousElementSibling;
    if (!prev || prev.getAttribute('data-lifase-original') !== 'true') {
      if (mine[m].parentNode) mine[m].parentNode.removeChild(mine[m]);
    }
  }

  var all = document.querySelectorAll('button, a');
  for (var i = 0; i < all.length; i++) {
    var el = all[i];
    if (el.getAttribute('data-lifase-checkout') === 'mine' || el.getAttribute('data-lifase-original') === 'true') continue;
    var text = (el.textContent || '').trim();
    if (!LIFASE_HIJACK_RE.test(text) || LIFASE_EXPRESS_RE.test(text)) continue;
    if (!el.parentNode) continue;
    var sib = el.nextElementSibling;
    if (sib && sib.getAttribute('data-lifase-checkout') === 'mine') continue;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = el.className;
    var inline = el.getAttribute('style');
    if (inline) btn.setAttribute('style', inline);
    btn.setAttribute('data-lifase-checkout', 'mine');
    btn.textContent = 'Proceed to Secure Checkout';
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      lifaseStartCheckout(this);
    });
    el.setAttribute('data-lifase-original', 'true');
    el.style.display = 'none';
    el.parentNode.insertBefore(btn, el.nextSibling);
  }
}

(function () {
  window.addEventListener('hashchange', function () {
    var hash = window.location.hash || '';
    if (LIFASE_CHECKOUT_INTENT.test(hash)) window.setTimeout(function () { lifaseStartCheckout(null); }, 400);
    window.setTimeout(function () { lifaseHijackCheckoutButtons(); lifaseFixCouponPlaceholder(); }, 300);
  });

  // Safety net for any other checkout-looking control (not our own button).
  document.addEventListener('click', function (event) {
    if (lifaseOnCheckoutPage()) return;
    var ctx = lifasePageContext();
    if (!ctx.isCart && !ctx.isProduct) return;
    var el = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!el) return;
    if (el.getAttribute('data-lifase-checkout') === 'mine' || el.getAttribute('data-lifase-original') === 'true') return;
    var text = (el.textContent || '').trim();
    if (!LIFASE_CHECKOUT_INTENT.test(text)) return;
    window.setTimeout(function () { lifaseStartCheckout(null); }, 900);
  }, true);

  function start() {
    lifaseHijackCheckoutButtons();
    lifaseFixCouponPlaceholder();
    window.setInterval(function () { lifaseHijackCheckoutButtons(); lifaseFixCouponPlaceholder(); }, 1200);
    document.addEventListener('click', function () {
      window.setTimeout(function () { lifaseHijackCheckoutButtons(); lifaseFixCouponPlaceholder(); }, 350);
    }, true);
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

// ---------------------------------------------------------------------
// LIFASE account / orders bridge (unchanged - see earlier notes)
// ---------------------------------------------------------------------
(function () {
  var ORDERS_INTENT = /my\s*orders|order\s*history|track\s*order/i;
  var ACCOUNT_INTENT = /account\s*&?\s*profile|my\s*account|^\s*login\s*$|^\s*sign\s*in\s*$/i;

  function onAccountPage() {
    return window.location.pathname.indexOf('/account') === 0;
  }

  function go(path) {
    window.setTimeout(function () {
      if (!onAccountPage()) window.location.href = path;
    }, 600);
  }

  document.addEventListener('click', function (event) {
    if (onAccountPage()) return;
    var el = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!el) return;
    var text = (el.textContent || '').trim();
    if (ORDERS_INTENT.test(text)) go('/account/orders');
    else if (ACCOUNT_INTENT.test(text)) go('/account');
  }, true);
})();

// ---------------------------------------------------------------------
// LIFASE loose/fuzzy search bridge (unchanged - see earlier notes)
// ---------------------------------------------------------------------
(function () {
  function runSearch(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    window.location.href = '/search?q=' + encodeURIComponent(term) + '&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last';
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var el = event.target;
    if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) return;
    var type = (el.getAttribute('type') || '').toLowerCase();
    var placeholder = (el.getAttribute('placeholder') || '').toLowerCase();
    if (type !== 'search' && placeholder.indexOf('search') === -1) return;
    runSearch(el.value);
  });

  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!el) return;
    var label = (el.getAttribute('aria-label') || '').toLowerCase();
    if (label.indexOf('search') === -1) return;
    var input = document.querySelector('input[type="search"], input[placeholder*="earch" i]');
    if (input && input.value) runSearch(input.value);
  }, true);
})();
